module.exports = "/_next/static/images/1653618475b71297cd77c433b9c2a645-hero-xs.jpg";